import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Card, Button } from 'antd'
import { CheckCircleOutlined } from '@ant-design/icons'
import { logoutUser } from '@actions/auth'
import './SignupSuccess.scss'

const SignupSuccess = () => {
  const [countdown, setCountdown] = useState(10)
  const dispatch = useDispatch()

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          // Use setTimeout to defer logout and avoid render cycle conflicts
          setTimeout(() => dispatch(logoutUser()), 0)
          return 0
        }
        return prev - 1
      })
    }, 1000)

    return () => clearInterval(timer)
  }, [dispatch])

  const handleLoginClick = () => {
    // Use setTimeout to defer logout and avoid any potential render cycle conflicts
    setTimeout(() => dispatch(logoutUser()), 0)
  }

  return (
    <div className="signup-success">
      <div className="success-container">
        <Card className="success-card">
          <div className="success-content">
            <CheckCircleOutlined className="success-icon" />
            <h1>Account Created Successfully!</h1>
            <p className="success-message">
              Your account has been created and is ready to use. You can now log in to access your dashboard.
            </p>
            <div className="success-actions">
              <Button type="primary" size="large" onClick={handleLoginClick}>
                Go to Login
              </Button>
              <p className="countdown-text">Redirecting automatically in {countdown} seconds...</p>
            </div>
          </div>
        </Card>
      </div>
    </div>
  )
}

export default SignupSuccess
